import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import classnames from 'classnames';
import UploadIcon from 'components/v2/icons/UploadIcon';
import CircleButton from 'components/v2/buttons/CircleButton';
import { getFilesWithContentType } from 'utils/files/files';
const CargomaticDropzone = React.forwardRef(({ disabled, style, className, onDrop, multiple, minSize, maxSize, acceptedFiles, dropzoneMessage, button, showIcon, dataTestId, }, ref) => {
    const onDropHandler = (files) => {
        if (!files || !files.length)
            return onDrop(files);
        const fileWithContentType = getFilesWithContentType(files);
        return onDrop(fileWithContentType);
    };
    const internalClassName = {
        flex: true,
        'm-auto': showIcon,
        'space-x-2': showIcon,
        'items-center': showIcon,
        'justify-end': showIcon,
    };
    return (React.createElement(Dropzone, { "data-testid": dataTestId, style: style, className: className, onDrop: onDropHandler, multiple: multiple, minSize: minSize, maxSize: maxSize, accept: acceptedFiles, disabled: disabled, ref: ref },
        React.createElement("div", { "data-testid": "div-18236de0", className: classnames(internalClassName) }, button ? (React.createElement(CircleButton, { dataTestId: "CircleButton-bf5a7c6e", onClick: () => { }, size: "small", color: "blue" },
            showIcon && React.createElement(UploadIcon, { className: "w-5 h-5" }),
            React.createElement("div", { "data-testid": "div-9135b438", className: "text-sm" }, dropzoneMessage))) : (React.createElement(React.Fragment, null,
            showIcon && React.createElement(UploadIcon, { className: "w-5 h-5" }),
            React.createElement("div", { "data-testid": "div-260ed7bf", className: "text-sm" }, dropzoneMessage))))));
});
CargomaticDropzone.displayName = 'CargomaticDropzone';
CargomaticDropzone.propTypes = {
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
    style: PropTypes.object,
    onDrop: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    multiple: PropTypes.bool,
    minSize: PropTypes.number,
    maxSize: PropTypes.number,
    dropzoneMessage: PropTypes.string,
    showIcon: PropTypes.bool,
};
CargomaticDropzone.defaultProps = {
    disabled: false,
    multiple: true,
    dropzoneMessage: 'Drop a file to upload',
    showIcon: true,
};
export default CargomaticDropzone;
